import getDevice from './module/getDevice.js'
import functions from './functions.js' 

function updateDeviceData() {
  const updatedDeviceData = getDevice()
  window.deviceData = updatedDeviceData
  return updatedDeviceData
}

updateDeviceData()

/* Ejecutar el getDevice si cambia el tamaño del navegador o rota el dispositivo */
window.addEventListener('resize', updateDeviceData)
window.addEventListener('orientationchange', updateDeviceData)

document.addEventListener('DOMContentLoaded', function () {
  functions(updateDeviceData())
})
